import React from "react";
import { useLang } from "../i18n/LanguageContext";
import { Search } from "lucide-react";

const Filters = ({ values, onChange, onSubmit, zones = [], compact = false }) => {
  const { t } = useLang();

  const inputClass =
    "w-full bg-[#FDFBF7] border border-[#E8DFD8] rounded-xl px-4 py-3 text-sm text-[#2C2621] focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]/30 focus:border-[#8B5A3C] transition-all appearance-none cursor-pointer";
  const labelClass = "block text-[11px] uppercase tracking-[0.18em] font-bold text-[#5C544B] mb-2";

  const set = (k, v) => onChange({ ...values, [k]: v });

  return (
    <form
      data-testid="property-filters"
      onSubmit={(e) => { e.preventDefault(); onSubmit?.(); }}
      className={`bg-white rounded-[2rem] shadow-xl border border-[#E8DFD8] p-6 md:p-8 ${compact ? "" : "-mt-20 relative z-20 mx-auto max-w-6xl"}`}
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 items-end">
        <div>
          <label className={labelClass}>{t.filters.contract}</label>
          <select
            data-testid="filter-contract"
            value={values.contract}
            onChange={(e) => set("contract", e.target.value)}
            className={inputClass}
          >
            <option value="all">{t.filters.anyContract}</option>
            <option value="sale">{t.filters.sale}</option>
            <option value="rent">{t.filters.rent}</option>
          </select>
        </div>
        <div>
          <label className={labelClass}>{t.filters.type}</label>
          <select
            data-testid="filter-type"
            value={values.type}
            onChange={(e) => set("type", e.target.value)}
            className={inputClass}
          >
            <option value="all">{t.filters.anyType}</option>
            <option value="apartment">{t.filters.apartment}</option>
            <option value="villa">{t.filters.villa}</option>
            <option value="house">{t.filters.house}</option>
            <option value="room">{t.filters.room}</option>
            <option value="commercial">{t.filters.commercial}</option>
            <option value="land">{t.filters.land}</option>
          </select>
        </div>
        <div>
          <label className={labelClass}>{t.filters.zone}</label>
          <select
            data-testid="filter-zone"
            value={values.zone}
            onChange={(e) => set("zone", e.target.value)}
            className={inputClass}
          >
            <option value="all">{t.filters.anyZone}</option>
            {zones.map((z) => <option key={z} value={z}>{z}</option>)}
          </select>
        </div>
        <div>
          <label className={labelClass}>{t.filters.maxPrice}</label>
          <input
            data-testid="filter-max-price"
            type="number"
            placeholder="€ 1.000.000"
            value={values.max_price || ""}
            onChange={(e) => set("max_price", e.target.value ? Number(e.target.value) : "")}
            className={inputClass.replace("cursor-pointer", "")}
          />
        </div>
        <button
          data-testid="filter-submit"
          type="submit"
          className="bg-[#8B5A3C] text-white hover:bg-[#704830] transition-colors rounded-xl px-6 py-3 text-sm font-medium flex items-center justify-center gap-2"
        >
          <Search size={16} />
          {t.filters.search}
        </button>
      </div>
    </form>
  );
};

export default Filters;
